import Axios from 'axios';


var headers = {
    'Content-Type': 'application/json',


}
export default {


    getAll() {
        const BASE_URL =  '/public/api';
        return Axios.get(BASE_URL + '/users', { headers: headers })
    },

    create(data) {
        const BASE_URL =  '/public/api';
        return Axios.post(BASE_URL + '/users', data, { headers: headers });

    },

    update(id, data) {
        const BASE_URL =  '/public/api';
        return Axios.put(BASE_URL + '/users/' + id, data, { headers: headers });
    },

    delete(id) {
        const BASE_URL =  '/public/api';
        return Axios.delete(BASE_URL + '/users/' + id, { headers: headers });
    },

    updateStatus(id, status) {
        const BASE_URL =  '/public/api';
        return Axios.post(BASE_URL + '/users/status/' + id + '/' + status, { headers: headers });

    },

}